import { SUPPORT_TICKETS_ENDPOINT, SUPPORT_STATISTICS_ENDPOINT, SUPPORT_RESPOND_ENDPOINT, SUPPORT_CATEGORY_ENDPOINT } from "../api-services/ApiEndpoints";

export const getAllTickets = async (userId = null) => {
    const url = userId 
        ? `${process.env.REACT_APP_API_URL}${SUPPORT_TICKETS_ENDPOINT}?user_id=${userId}`
        : `${process.env.REACT_APP_API_URL}${SUPPORT_TICKETS_ENDPOINT}`;
    const token = localStorage.getItem('token');
    
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'accept': '*/*'
        }
    });
    
    if (!response.ok) {
        throw new Error(`Failed to fetch tickets: ${response.status}`);
    }
    
    return await response.json();
};

export const getTicketStatistics = async () => {
    const url = `${process.env.REACT_APP_API_URL}${SUPPORT_STATISTICS_ENDPOINT}`;
    const token = localStorage.getItem('token');
    
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'accept': '*/*'
        }
    });
    
    if (!response.ok) {
        throw new Error(`Failed to fetch statistics: ${response.status}`);
    }
    
    return await response.json();
};

export const respondToTicket = async (ticketId, adminResponse, status) => {
    const url = `${process.env.REACT_APP_API_URL}${SUPPORT_RESPOND_ENDPOINT}/${ticketId}/respond`;
    const token = localStorage.getItem('token');
    
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'accept': '*/*'
        },
        body: JSON.stringify({
            admin_response: adminResponse,
            status: status
        })
    });
    
    if (!response.ok) {
        throw new Error(`Failed to respond to ticket: ${response.status}`);
    }
    
    return await response.json();
};

export const getTicketsByCategory = async (category) => {
    const url = `${process.env.REACT_APP_API_URL}${SUPPORT_CATEGORY_ENDPOINT}/${category}`;
    const token = localStorage.getItem('token');
    
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'accept': '*/*'
        }
    });
    
    if (!response.ok) {
        throw new Error(`Failed to fetch tickets by category: ${response.status}`);
    }
    
    return await response.json();
};
